module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1a.71285866.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-3-1a.mp3
// module id = 573
// module chunks = 0